__turbopack_context__.v({
  "bounce": "LocationPin-module__bqOwIa__bounce",
  "location-pin-wiggle": "LocationPin-module__bqOwIa__location-pin-wiggle",
  "mdOnly": "LocationPin-module__bqOwIa__mdOnly",
  "motionSlot": "LocationPin-module__bqOwIa__motionSlot",
  "reducedStatic": "LocationPin-module__bqOwIa__reducedStatic",
  "root": "LocationPin-module__bqOwIa__root",
  "svg": "LocationPin-module__bqOwIa__svg",
  "tint": "LocationPin-module__bqOwIa__tint",
  "wiggle": "LocationPin-module__bqOwIa__wiggle",
});
